<template>
   <a-form ref='ruleForm' :rules="rules" :model='form' :labelCol="{span:4}"  :wrapper-col="{span:18}">
      <a-form-item label="客户标签"   >
        <a-select v-model:value="form.user_label_id" style="width:100%" mode="multiple" placeholder="请选择客户标签">
            <a-select-option v-for='item in options' :key='item+"label"' :value="item.id" >{{item.tag_name}}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="会员等级"  >
          <a-select v-model:value="form.user_vip_id" :style="{width:'100%'}" mode="multiple" placeholder="请选择会员等级">
            <a-select-option v-for='item in vipList' :key='item.vip_id+"vip"' :value="item.vip_id">{{item.vip_name}}
            </a-select-option>
          </a-select>
       </a-form-item>
            <a-form-item :wrapper-col="{offset:4}">
         <a-button @click="submit" type="primary">确定</a-button>
       </a-form-item>
   </a-form>
</template>

<script>
import { onMounted, ref } from 'vue'
import { iscode } from '@/utils/app'
import {  getMemberTagList,getMemberVip} from '@/api/member'
import { message } from 'ant-design-vue'
const rules={
  user_label_id:[{type:'array',required:true,message:'请选择客户标签'}],
  user_vip_id:[{type:'array',required:true,message:'请选择会员等级'}]
}
export default {
  porps:{ployDetail:Object},
  setup(props,{emit}){
      const ruleForm=ref()
      const form=ref({user_vip_id:[], user_label_id:[],rule_mark_user:1})
   
          //获取标签
      const options=ref([])
      const getTagsList = async () => {
        let res = await getMemberTagList({limit:99}).then((res) => res.data);
        if (iscode(res)) {
          options.value = res.data.data;
         const labels= options.value.map(v=>v.id)
         form.value.user_label_id=form.value.user_label_id.filter(el=>{return labels.indexOf(el)!=-1})
        }
      };
      const vipList=ref([])
     const getVip = async () => {
        let res = await getMemberVip().then((res) => res.data);
        if (iscode(res)) {
          vipList.value = res.data;
          const vips=vipList.value.map(v=>v.vip_id)
         form.value.user_vip_id.filter(el=>{return vips.indexOf(el)!=-1})
        }
      };
         const submit=()=>{
         ruleForm.value.validate().then(async(res)=>{
          if(!form.value.user_label_id.length&&!form.value.user_vip_id.length){
            message.error('标签和等级至少选择一项')
            return
          }
          var label=options.value.filter(v=>form.value.user_label_id.indexOf(v.id)!=-1)
          var vip=vipList.value.filter(v=>form.value.user_vip_id.indexOf(v.vip_id)!=-1)
          form.value.user_label_id=[]
          label.forEach(v=>{
             form.value.user_label_id.push({
               id:v.id,
               tag_name:v.tag_name
            })
          })
          form.value.user_vip_id=[]
          vip.forEach(v=>{
             form.value.user_vip_id.push({
               vip_id:v.vip_id,
               vip_name:v.vip_name
            })
          })
          emit('ployDone',{...form.value,label,vip})
        }).catch(error=>error)
      }
      const renderDetail=(data,index)=>{
        console.log(data)
         form.value=data
         form.value.index=index
      
         form.value.user_vip_id=data.vip.map(v=>v.vip_id)
         form.value.user_label_id=data.label.map(v=>v.id)
      }
      onMounted(()=>{
        getTagsList()
        getVip()
      })
      return{
        form,
        ruleForm,
        rules,
        submit,
        options,
        vipList,
        renderDetail
      }
  }
}
</script>